import { Divider, Form, Modal,Dropdown, Tabs } from 'antd'
import LeftArrow from 'assets/icons/LeftArrow'
import Avatar from 'components/Avatar'
import Label from 'components/Label/Label'
import RoutePath from 'components/route_path/RoutePath'
import {
  Content,
  DisplayPad,
  MailSubHeading,
  RowPadding,
} from 'modules/ManageProfile/Style/style'
import JobDescription from 'modules/ViewRole/Style/JobDescription'
import {
  Address,
  BreadCrumns,
  CenteredDiv,
  ColListIcon,
  Container,
  DropRow,
  Name,
  NameAdd,
  OuterDiv,
  RowContainer,
  RowListIcon,
  RowListLabel,
  SectionWrapper,
  ShareTitile,
  TopHeader,
  TopNav,
} from 'modules/ViewRole/Style/style'
import React, { useEffect, useState } from 'react'
import { Link,useParams } from 'react-router-dom'
import Button from 'components/Button'
import Flex from 'components/Flex'
import AntdInput from 'components/Form/Input'
import StyledTabs from 'components/TabsPaneStyles/index'
import CheckTick from 'components/icons/CheckCircleIcon'
import CopyAltIcon from 'components/icons/CopyAltIcon'
import CrossIcon from 'components/icons/CrossIcon'
import EmailAtIcon from 'components/icons/EmailAtIcon'
import FacebookIcon1 from 'components/icons/FacebookIcon1'
import HeartFilled from 'components/icons/HeartFilled'
import HeartOutLine from 'components/icons/HeartOutLine'
import LinkedIcon1 from 'components/icons/LinkedIcon1'
import Share from 'components/icons/Share'
import TwitterIcon from 'components/icons/TwitterIcon'
import WhatsappIcon from 'components/icons/WhatsappIcon'
import Emptystates from 'components/icons/emptystates.svg'
import ConfirmDrawer from 'modules/ViewRole/Style/ConfirmDrawer'
import AboutCompany from 'modules/ViewSingleRole/Style/AboutCompany'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share'
import SuccessMessage from 'utils/SuccessMessage'
import { StyledDiv } from '../Dashboard/Style/style'

const { TabPane } = Tabs

const ViewRole = ({
  viewRoleData,
  SaveRole,
  getSingleRoleDetails,
  viewRoleDetails,
  ApplyRole,
  collegeData,
  jobSharingEmail,
}) => {
  const params = useParams()
  useEffect(() => {
    getSingleRoleDetails(params.CorpID, params.JobID)
  }, [])

  const [drawer, setDrawer] = useState(false)
  const [shareOption, setShareOption] = useState(false)
  const [emailModel, setEmailModel] = useState(false)
  const { PIL_WEBSITE_URL } = process.env
  const shareUrl = `${PIL_WEBSITE_URL}/job/${params.CorpID}/${params.JobID}`
  const onApplyClick = param => {
    const newState = { ...viewRoleDetails, isApplied: 1 }
    ApplyRole(newState)
  }
  const showDrawer = () => {
    setDrawer(true)
  }

  const ShareWork = () => {
    setShareOption(true)
  }
  const ShareCancel = () => {
    setShareOption(false)
  }

  const copyLink = () => {
    let copyText = document.getElementById('socilamedialink')
    copyText.select()
    navigator.clipboard.writeText(copyText.value)
    if (copyText.value?.length != 0) {
      SuccessMessage('Link Coppied!')
    }
  }

  const handleEmailOnClick = () => {
    setEmailModel(true)
  }
  const handleEmailCancel = () => {
    setEmailModel(false)
  }
  const onEmailEntered = e => {
   
  }
  const sendEmailOTP = async values => {
    let payload = {
      email: values?.Email,
      link: shareUrl,
    }
    jobSharingEmail(payload)
    setEmailModel(false)
  }
  const menu = (
    <DropRow>
      <TopHeader row spaceBetween alignCenter>
        <ShareTitile flexStart>Share this role</ShareTitile>
        <div style={{ cursor: 'pointer', marginTop: 5 }}>
          <Avatar onClick={ShareCancel} size={20} src={<CrossIcon />} />
        </div>
      </TopHeader>
      <Divider />
      <RowListIcon row>
        <ColListIcon column alignCenter>
          <LinkedinShareButton url={shareUrl}>
            <Avatar
              size={72}
              src={<LinkedIcon1 />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </LinkedinShareButton>

          <RowListLabel>Linked In</RowListLabel>
        </ColListIcon>
        <ColListIcon column alignCenter>
          <FacebookShareButton url={shareUrl}>
            <Avatar
              size={72}
              src={<FacebookIcon1 />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </FacebookShareButton>
          <RowListLabel>Facebook</RowListLabel>
        </ColListIcon>
        <ColListIcon column alignCenter>
          <TwitterShareButton url={shareUrl}>
            <Avatar
              size={72}
              src={<TwitterIcon />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </TwitterShareButton>

          <RowListLabel>Twitter</RowListLabel>
        </ColListIcon>
        <ColListIcon column alignCenter>
          <EmailShareButton onClick={handleEmailOnClick} url={shareUrl}>
            <Avatar
              size={72}
              src={<EmailAtIcon />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </EmailShareButton>

          <RowListLabel>E-Mail</RowListLabel>
        </ColListIcon>
        <ColListIcon column alignCenter>
          <WhatsappShareButton url={shareUrl}>
            <Avatar
              size={72}
              src={<WhatsappIcon />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </WhatsappShareButton>
          <RowListLabel>Whatsapp</RowListLabel>
        </ColListIcon>
      </RowListIcon>
      <CenteredDiv>Or share with link</CenteredDiv>
      <AntdInput
        id={'socilamedialink'}
        value={shareUrl}
        disabled={true}
        suffix={
          <StyledDiv style={{ cursor: 'pointer', marginTop: 5 }} onClick={copyLink}>
            <CopyAltIcon />
          </StyledDiv>
        }
      />
    </DropRow>
  )
  const CheckIcon = corporate => {
    if (corporate?.logo) {
      return <Avatar size={64} src={corporate?.logo} />
    } else {
      return (
        <Avatar
          background
          size={64}
          IconName={corporate?.name?.[0] ?? corporate?.companyName?.[0]}
          font={18}
        />
      )
    }
  }
  const HeartClicked = () => {
    let payLoad = {
      id: viewRoleDetails?.role?.id,
      isSaved: viewRoleDetails?.isSaved === 1 ? 0 : 1,
    }
    SaveRole(payLoad)
  }

  const DateCompare = () => {
    let today = new Date()
    let endDate = new Date(
      new Date(viewRoleDetails?.role?.endDate).setUTCHours(18, 29, 59, 999)
    )

    if (endDate < today) {
      return <Button.Danger text={'Application Closed'} />
    } else {
      return (
        <Button.Primary
          onClick={showDrawer}
          text={'Apply'}
          width={'300px'}
          disabled={!viewRoleDetails?.isLocationEligible}
        />
      )
    }
  }
  const ExtraAction = () => {
    return (
      
        <Container alignEnd>
          {viewRoleDetails?.isApplied === 0 ? (
            DateCompare()
          ) : (
            <Button.Success
              icon={<Avatar size={20} src={<CheckTick />} />}
              text={'Applied'}
              width={'60%'}
            />
          )}
          &nbsp;&nbsp; &nbsp;&nbsp;
          <Dropdown onClick={ShareWork} overlay={menu} visible={shareOption}>
            <Button.Round icon={<Share />}  width="20%"/>
          </Dropdown>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button.Round
            padding={'10px'}
            onClick={HeartClicked}
            width="20%"
            icon={
              <>
                {viewRoleDetails?.isSaved == 1 ? (
                  <HeartFilled />
                ) : (
                  <HeartOutLine />
                )}
              </>
            }
          />
        </Container>
      
    )
  }
  return (
    <>
      <SectionWrapper column>
        <OuterDiv>
          <TopNav>
            <BreadCrumns>
              <Link style={{ margin: '2px 8px 0px 0px ' }} to="/applied_roles">
                <LeftArrow />
              </Link>
              <RoutePath
                from="Applied Roles"
                on="Job Details"
                path="/applied_roles"
              />
            </BreadCrumns>

            <br />
            {(viewRoleDetails?.role?.corporate ||
              viewRoleDetails?.role?.company) && (
              <Flex centerVertically alignCenter style={{ margin: 15 }}>
                {CheckIcon(
                  viewRoleDetails?.role?.corporate ??
                    viewRoleDetails?.role?.company
                )}
                <NameAdd column flexStart>
                  <Name>
                    {viewRoleDetails?.role?.corporate?.name ??
                      viewRoleDetails?.role?.company?.companyName}
                  </Name>
                  <Address>
                    {viewRoleDetails?.role?.corporate?.industry ??
                      viewRoleDetails?.role?.company?.industry}
                  </Address>{' '}
                </NameAdd>
              </Flex>
            )}
          </TopNav>
          <RowContainer>
            <StyledTabs
              width={'100%'}
              tabBarExtraContent={ExtraAction()}
              defaultActiveKey="1"
            >
              <TabPane tab="Job Description" key="1">
                {viewRoleDetails && (
                  <JobDescription
                    viewRoleData={viewRoleDetails}
                    collegeData={collegeData}
                    onApplyClick={onApplyClick}
                  />
                )}
              </TabPane>
              {viewRoleDetails?.role?.corporate && (
                <TabPane tab="About Company" key="2">
                  <AboutCompany viewRoleData={viewRoleDetails} />
                </TabPane>
              )}
            </StyledTabs>
          </RowContainer>
        </OuterDiv>
      </SectionWrapper>
      {drawer && (
        <ConfirmDrawer
          drawer={drawer}
          setDrawer={setDrawer}
          dataSelected={viewRoleDetails?.role}
          onApplyClick={onApplyClick}
          collegeData={collegeData}
        />
      )}
      <Modal
        width={'585px'}
        open={emailModel}
        footer={null}
        onCancel={handleEmailCancel}
      >
        <RowPadding>
          <Content alignCenter column center>
            <Flex>
              <img src={Emptystates} alt='EmptyState'/>
            </Flex>

            <MailSubHeading>Share Job with your friends</MailSubHeading>
          </Content>
          <Form
            style={{ width: '100%' }}
            scrollToFirstError
            onFinish={sendEmailOTP}
            id={'emailForm'}
            layout="vertical"
          >
            <Label>Your friend's email address *</Label>
            <AntdInput
              AntdInput
              placeholder="eg:harry@yahoo.com"
              width="100%"
              name="Email"
              type="email"
              onChange={onEmailEntered}
              rules={[
                {
                  required: true,
                  message: 'Please enter primary email!',
                },
                {
                  type: 'email',
                  message: 'Please enter valid email',
                },
              ]}
            />

            <DisplayPad>
              <Button.Primary
                htmlType="submit"
                text={'Submit'}
                width={'100%'}
                padding={'10px'}
              />
            </DisplayPad>
          </Form>
        </RowPadding>
      </Modal>
    </>
  )
}
export default ViewRole
